module.exports = __webpack_public_path__ + "img/a3f7d30.jpg";